import React, {useMemo, useState}					from 'react';
import {useNavigate}								from 'react-router-dom';

import Badge										from '../ressources/components/Badge';
import Button										from '../ressources/components/Button';
import Select										from '../ressources/components/Select';
import Tabs											from '../ressources/components/Tabs';
import DeviceImage									from '../ressources/components/Device/DeviceImage';
import Icon											from '../ressources/components/Icon';
import QuantitySelect								from '../ressources/components/QuantitySelect';
import Modal										from '../ressources/components/Modal';

import {useAppDispatch, useAppSelector}				from '../app/hooks';
import {TabsData}									from '../ressources/components/Tabs/interface';
import {clearHeader}								from '../redux/settings/settings';
import {addToBasket, removeToBasket, basketChangeLink, openBasket, closeBasket} from '../redux/basket/basket';
import {ft_genLinkId, ft_getUnlinkedDevices} from '../ressources/functions/basketFunction';

import useWindowSize								from '../ressources/functions/useWindowSize';
import ft_cssVar									from '../ressources/functions/getCssVar';
import {ft_formatPrice}								from '../ressources/functions/format';
import {ft_getDeviceCatalogPrice}					from '../ressources/functions/deviceFunction';
import {ft_checkRight}								from '../ressources/functions/userFunction';

import img_basketEmpty								from '../ressources/images/basket-empty.png';
import img_truck									from '../ressources/images/icon/truck.svg';
import img_calendar									from '../ressources/images/icon/calendar-date.svg';
import img_flipBackward								from '../ressources/images/icon/flip-backward.svg';
import img_info								from '../ressources/images/icon/info-circle.svg';

import LANGUAGE										from '../ressources/language';

import './Header.css';
import {Catalog} from '../redux/catalog/interface';

type OptionsList = 'screenSize' | 'stockage' | 'processor' | 'state' | 'network' | 'graphicCard' | 'memory' | 'keyboard';

interface HeaderProps {
	title: string,
	badgeText?: string | number,
	menu?: Array<TabsData>
	menuValue?: string,
	basket?: boolean
}

function Header(props: HeaderProps) {
	const dispatch = useAppDispatch();
	const size = useWindowSize();
	const basket = useAppSelector(state => state.basket);
	const user = useAppSelector(state => state.user.data);
	const address = useAppSelector(state => state.address.data);
	const forceHeader = useAppSelector(state => state.settings.forceHeaderFunction);
	const lang = useAppSelector(state => state.settings.lang);

	const [seeProperty, set_seeProperty] = useState('');

	const mainAddress = useMemo(() => address.find(find => find.main)?._id, [address]);

	const TEXTE = LANGUAGE(lang);
	const navigate = useNavigate();

	const ADD_LIST = [
		{render: TEXTE.menu.devices, value: '/devices/add'},
		{render: TEXTE.menu.users, value: '/users/onboarding'},
		{render: TEXTE.menu.contracts, value: '/contracts/add'}
	];

	if (size.width && size.width < 1140)
		ADD_LIST.unshift({render: TEXTE.menu.order, value: '/order/catalog'});

	let actualMenu = props.menuValue;
	let actualMenuData: TabsData | undefined;

	if (actualMenu) {
		actualMenu = actualMenu.split('/')[0];
		actualMenuData = props.menu?.find(find => find.value === actualMenu);
	}

	const renderPropertiyLine = (name: OptionsList, value: string) => {
		if (value)
			return <li className={'orderNewBasketPropertyLine'}>{`${TEXTE.global[name]} : ${value}`}</li>;
	};

	function renderModalBasket() {
		const render: React.ReactElement[] = [];

		const chargerNeeded: Record<string, number> = {};
		basket.data.forEach((b) => {
			const c = b.device.category.needCharger ? b.device.category.charger : null;
			if (c?._id)
				chargerNeeded[c._id] = (chargerNeeded[c._id] || 0) + b.quantity;
		});

		const chargerInBasket: Record<string, number> = {};
		basket.data.forEach((b) => {
			chargerInBasket[b.device._id] = (chargerInBasket[b.device._id] || 0) + b.quantity;
		});

		basket.data.forEach((basketData) => {
			const propertyOpen = seeProperty === `${basketData.device._id}-${basketData.keyboard || ''}`;
			const charger = basketData.device.category.charger;
			const chargerMissing = charger?._id
				? (chargerNeeded[charger._id] || 0) - (chargerInBasket[charger._id] || 0)
				: 0;
			const toLink = charger?._id
				? ft_getUnlinkedDevices(basket.data, charger._id)
				.filter(u => u.entry === basketData)
				.slice(0, Math.max(chargerMissing, 0))
				: [];
			let price = ft_getDeviceCatalogPrice(basketData.device, 36);
			let duration = 36;

			if (basketData.duration !== 36) {
				const findPrice = basketData.device.extendedPrice?.find(find => find.month === basketData.duration);

				if (findPrice) {
					price = findPrice.price;
					duration = findPrice.month;
				}
			}

			console.log(basketData.device);

			render.push(
				<div className={'orderNewBaskerItem'}>
					<div>
						<DeviceImage catalog={basketData.device} className={'orderNewBaskerItemImg'}imageFormat={'small'} />
						<div className={'orderNewBaskerItemData'}>
							<span>{basketData.device.category?.name}</span>

							<span
								className={`orderDataDeviceProperty ${propertyOpen ? 'open' : 'close'}`}
								onClick={() => set_seeProperty(propertyOpen ? '' : `${basketData.device._id}-${basketData.keyboard || ''}`)}
							>
								{TEXTE.order.seeProperty}
							</span>
							{propertyOpen &&
								<ul>
									{renderPropertiyLine('state', basketData.device.info.state)}
									{renderPropertiyLine('screenSize', basketData.device.info.screenSize)}
									{renderPropertiyLine('processor', basketData.device.info.processor)}
									{renderPropertiyLine('memory', basketData.device.info.memory)}
									{renderPropertiyLine('stockage', basketData.device.info.stockage)}
									{renderPropertiyLine('graphicCard', basketData.device.info.graphicCard)}
									{renderPropertiyLine('network', basketData.device.info.network)}
									{basketData.keyboard && renderPropertiyLine('keyboard', basketData.keyboard)}
								</ul>
							}

							<div className={'orderNewBasketDataIconText'}>
								<Icon icon={img_truck} iconColor={ft_cssVar('gray-800')} />
								<span>{TEXTE.order.deliveryDay}</span>
							</div>
							<div className={'orderNewBasketDataIconText'}>
								<Icon icon={img_calendar} iconSize={16} iconColor={ft_cssVar('gray-800')} />
								<span>{`${duration} ${TEXTE.global.month}`}</span>
							</div>
							<div className={'orderNewBasketPriceLine'}>
								<QuantitySelect
									delete
									value={basketData.quantity}
									onClickLess={() => {
										dispatch(removeToBasket({
											user,
											quantity: 1,
											device:   basketData.device,
											keyboard: basketData.keyboard,
											duration: basketData.duration
										}));
									}}
									onClickPlus={() => {
										dispatch(addToBasket({
											user,
											quantity:  1,
											addressId: mainAddress,
											device:    basketData.device,
											keyboard:  basketData.keyboard,
											duration:  basketData.duration
										}));
									}}
								/>
								<span className={'text-sm weight-600 gray-800'}>{ft_formatPrice(basketData.quantity * price)}<span className={'text-xs weight-400 gray-400'}>{`/${TEXTE.global.month}`}</span></span>
							</div>
						</div>
					</div>
					{(basketData.device.category.needCharger && charger && toLink.length > 0) &&
						<>
							<Badge fullWidth size={'lg'} color={'warning'} text={TEXTE.order.noCharger} >
								<Icon
									icon={img_info}
									iconColor={ft_cssVar('warning-600')}
									popupStyle={{width: 390}}
									popup={
										<>
											<b>{TEXTE.order.chargerPopup.title}</b><br />
											{TEXTE.order.chargerPopup.text}<br />
											{basketData.device.info.brand.toLowerCase() === 'apple' ? TEXTE.order.chargerPopup.apple : ''}
										</>
									}
								/>
							</Badge>
							<div className={'orderNewBasketCharger'}>
								<DeviceImage catalog={charger as Catalog} className={'orderNewBaskerItemImg'} imageFormat={'small'} />
								<div className={'orderNewBaskerItemData'}>
									<span>{charger.name}</span>

									<div className={'orderNewBasketPriceLine'}>
										<Button
											size={'sm'}
											style={{padding: 4}}
											onClick={() => {
												const links = toLink.map(t => t.entry.link?.[t.index] || ft_genLinkId());

												toLink.forEach((t, i) => dispatch(basketChangeLink({
													user,
													index:    t.index,
													deviceId: t.entry.device._id,
													keyboard: t.entry.keyboard,
													duration: t.entry.duration,
													newId:    links[i]
												})));

												dispatch(addToBasket({
													user,
													quantity:  toLink.length,
													addressId: mainAddress,
													duration:  basketData.duration,
													device:    charger as Catalog,
													link:      links
												}));
											}}
										>{'Ajouter'}</Button>
										<span className={'text-sm weight-600 gray-800'}>{ft_formatPrice(chargerMissing * charger.price)}<span className={'text-xs weight-400 gray-400'}>{`/${TEXTE.global.month}`}</span></span>
									</div>
								</div>
							</div>
						</>
					}
				</div>
			);
		});

		return (
			<Modal
				modalRight
				onClose={() => dispatch(closeBasket())}
				cancelButton={basket.quantity > 0 ? () => dispatch(closeBasket()) : undefined}
				cancelButtonText={basket.quantity > 0 ? TEXTE.order.continuePurchase : undefined}
				confirmButtonText={basket.quantity > 0 ? TEXTE.order.validAndContinue : TEXTE.order.backCatalog}
				confirmButton={() => {
					if (basket.quantity > 0)
						navigate(`/order/catalog/confirm${window.location.search}`);
					dispatch(closeBasket());
				}}
				header={
					<span className={'text-xl weight-600 gray-900'}>{`${TEXTE.order.myBasket}: `}
						<span className={'gray-500'}>{`${basket.quantity} ${basket.quantity > 1 ? TEXTE.order.objects : TEXTE.order.object}`}</span>
					</span>
				}
				footer={
					<div>
						<div className={'orderDataTotalLine'}>
							<span>{TEXTE.global.subTotal}</span>
							<span>{`${ft_formatPrice(basket.price)} HT`}</span>
						</div>
						<div className={'orderDataTotalLine'}>
							<span>{TEXTE.global.delivery}</span>
							<span>{TEXTE.global.free}</span>
						</div>
						<div className={'orderDataTotalLine big'}>
							<span>{TEXTE.global.total}</span>
							<span>{ft_formatPrice(basket.price)}<span className={'text-regular'}>{` HT/${TEXTE.global.month}`}</span></span>
						</div>
						<br />
					</div>
				}
			>
				{basket.quantity > 0 ?
					render
					:
					<div className={'orderNewBasketEmpty'}>
						<img src={img_basketEmpty} alt={''} />
						<span className={'text-md gray-600 weight-500'}>{TEXTE.order.basketEmpty}</span>
					</div>
				}
			</Modal>
		);
	}

	if (forceHeader) {
		return (
			<div className={'header minimize'}>
				<div
					onClick={() => {
						forceHeader.function();
						dispatch(clearHeader());
					}}
				>
					<Icon icon={img_flipBackward} />
					<span className={'text-sm weight-500 gray-600'}>{forceHeader.render}</span>
				</div>

				<div className={'flex'} />

				{props.basket &&
					<div className={'orderNewHeaderBasket'} onClick={() => dispatch(openBasket())}>
						<div><span>{basket.quantity}</span></div>
					</div>
				}
				{basket.open && renderModalBasket()}
			</div>
		);
	}

	if (actualMenuData?.minimizeHeader) {
		let isMinimize = !actualMenuData.minimizeHeaderUrl;

		if (!isMinimize)
			isMinimize = !!actualMenuData.minimizeHeaderUrl?.some(find => find === props.menuValue);

		if (isMinimize) {
			return (
				<div className={'header minimize'}>
					<div onClick={() => navigate(actualMenuData?.minimizeHeaderNavigate || '')}>
						<Icon icon={img_flipBackward} />
						<span className={'text-sm weight-500 gray-600'}>{actualMenuData.minimizeHeader}</span>
					</div>
				</div>
			);
		}
	}

	return (
		<div className={'header'}>
			<div className={'headerTitle display-sm'}>
				<span>{props.title}</span>
				{props.badgeText ?
					<Badge
						size={'sm'}
						text={props.badgeText}
						style={{alignSelf: 'center'}}
					/>
					:
					undefined
				}

				<div className={'flex'} />

				{(!props.basket && ft_checkRight(user, 'company.edit')) &&
					<div>
						<Select
							size={'md'}
							data={ADD_LIST}
							placeholder={TEXTE.global.add}
							onChange={val => navigate(val as string)}
							style={{marginLeft: 12, marginRight: 12}}
							placeholderClassname={'weight-600 gray-600'}
						/>
					</div>
				}

				{(!props.basket && (!size.width || size.width >= 1140) && ft_checkRight(user, 'company.edit')) &&
					<Button
						type={'primary'}
						onClick={() => navigate('/order/catalog')}
					>
						{TEXTE.header.newCommand}
					</Button>
				}

				{props.basket &&
					<div className={'orderNewHeaderBasket'} onClick={() => dispatch(openBasket())}>
						<div><span>{basket.quantity}</span></div>
					</div>
				}
			</div>

			{props.menu &&
				<Tabs
					alignLeft
					noFocusCss
					button={'sm'}
					data={props.menu}
					onChange={val => navigate(`${val}`)}
					actual={actualMenuData ? actualMenu : ''}
				/>
			}

			{basket.open && renderModalBasket()}
		</div>
	);
}

export default Header;
